import { Typography } from '@material-ui/core';
import { PortraitSharp } from '@material-ui/icons';
import { Dispatch, SetStateAction } from 'react';
import { Button } from '../../../../themes/components/Button';

interface TypeFooterMenuNovoPedido {
    totalValuePedido: number;
    qtdToatalItens: number;
    regraAddItens: boolean;
    regraCancelar: boolean;
    regraResumo: boolean;
    regraEnviar: boolean;
    regraSalvar: boolean;
    regraNovoPedido: boolean;
    funcAddItens: () => void;
    funcCancelar: () => void;
    funcResumo: Dispatch<SetStateAction<number>>;
    funcEnviar: () => void;
    funcNovoPedido: () => void;
    funcSalvar: () => void;
}

export const FooterMenuNovoPedido = (props: TypeFooterMenuNovoPedido) => {
    return (
        <div className="container-footer-novo-pedido">
            <div className="footer-novo-pedido-info-area">
                <Typography className="footer-novo-pedido-info-text"><b>Quantidade Total:</b> {props.qtdToatalItens.toLocaleString('pt-br', { style: 'decimal', maximumFractionDigits: 2 })}</Typography>
                <Typography className="footer-novo-pedido-info-text"><b>Valor Total:</b> {props.totalValuePedido.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Typography>
            </div>
            <div className="footer-novo-pedido-botoes-area">
                {props.regraAddItens ? <Button onClick={() => props.funcAddItens() } classBtn={"btn-footer-novo-pedido color-default"}>Adicionar Itens</Button> : <></>}
                {props.regraResumo ? <Button onClick={() => props.funcResumo(3) } classBtn={"btn-footer-novo-pedido color-default"}>Resumo</Button> : <></>}
                {props.regraSalvar ? <Button onClick={() => props.funcSalvar() } classBtn={"btn-footer-novo-pedido color-default"}>Salvar</Button> : <></>}
                {props.regraNovoPedido ? <Button onClick={() => props.funcNovoPedido() } classBtn={"btn-footer-novo-pedido color-default"}>Novo Pedido</Button> : <></>}
                {props.regraCancelar ? <Button onClick={() => props.funcCancelar() } classBtn={"btn-footer-novo-pedido color-red"}>Cancelar Pedido</Button> : <></>}
                {props.regraEnviar ? <Button onClick={() => props.funcEnviar() } classBtn={"btn-footer-novo-pedido color-green"}>Enviar</Button> : <></>}
            </div>
        </div>
    )
}